//TODO Added temporary for dev purpose, need to remove
const initialState =
    [
        {
            personalizationCode: "SUMMER_2026_PROMO",
            heading: "Beat the Heat",
            subHeading: "Exclusive discounts on summer essentials",
            placementCode: "HOME_BANNER_01",
            itemDetails: [
                {
                    orderId: 1,
                    itemID: 47918,
                    itemCode: "951015",
                    name: "Top Crust Bread 420g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
                {
                    orderId: 1,
                    itemID: 47924,
                    itemCode: "951015",
                    name: "Top Crust Bread 420g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
                {
                    orderId: 1,
                    itemID: 47923,
                    itemCode: "951015",
                    name: "Top Crust Bread 450g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
                {
                    orderId: 1,
                    itemID: 47922,
                    itemCode: "951015",
                    name: "Top Crust Bread 450g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
                {
                    orderId: 1,
                    itemID: 47921,
                    itemCode: "951015",
                    name: "Top Crust Bread 450g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
                {
                    orderId: 1,
                    itemID: 47920,
                    itemCode: "951015",
                    name: "Top Crust Bread 450g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
                {
                    orderId: 1,
                    itemID: 47919,
                    itemCode: "951015",
                    name: "Top Crust Bread 450g",
                    longDescription: "TOP CRUST BREAD 450G",
                    amount: 149,
                    imageUrl: "https://essstr.blob.core.windows.net/essimg/350x/Small/Pic951015.jpg",
                    enlargeImageUrl: "",
                    isFeatured: false,
                    isSponsored: false,
                    minQty: 1,
                    maxQty: 99,
                    slabQty: 1,
                    stockInHand: 500,
                    averageSale: 224.67,
                    uom: "NO",
                    isPromotionApplied: true,
                    promotionDiscountValue: 0,
                    discountValue: 0,
                    promoDetailIDs: null,
                    discountedTotal: 0,
                    isAvailable: true,
                    quantity: 0,
                    checkAge: false,
                    departmentCode: "K",
                    subDepartmentCode: "KW2",
                    categoryCode: "KW2SP",
                    styleBorderColor: "",
                    styleImageURL: "",
                    isSellingToday: true,
                    isUpdateQuantity: false,
                    merchantID: 1,
                    hasMoreDeals: 0,
                    detailDescription: null,
                    clickTrackingURL: null
                },
            ]
        }
    ];

export const personalizationDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PERSONALIZATION_DATA':
            // return action.payload //TODO Comment temporary for dev purpose
            return initialState
        case 'RESET_PERSONALIZATION_DATA':
            return []
        default:
            return state
    }
};